/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar, Nav, Image, Dropdown, Button } from 'react-bootstrap';
import { $user, $app } from 'signals/global.signals';

const NavHeader = () => {
  const navigate = useNavigate();
  const toggleMenu = () => {
    $app.value = {
      ...$app.value,
      isMenuOpen: !$app.value.isMenuOpen,
    };
  };
  return (
    <Navbar
      expand="lg"
      style={{ zIndex: 1010 }}
      className="navbar navbar-expand-lg px-md-32 px-16 bg-gradient-dark-primary sticky-top"
    >

      <Navbar.Brand href={$user.value.userType === 'founder' ? '/founder/dashboard' : '/investor/dashboard'}>
        <Image
          className="nav-logo"
          src="/images/logo-light.svg"
          height="100%"
        />
      </Navbar.Brand>
      <div className="ms-auto d-flex align-items-center text-white">
        <Dropdown drop="down-centered">
          <Dropdown.Toggle
            className="btn-text bg-transparent border-0 fw-500 p-0  text-white "
            style={{ fontSize: '1rem' }}
          >
            {`${$user.value.firstName} ${$user.value.lastName}`}
          </Dropdown.Toggle>
          <Dropdown.Menu className="text-center p-0">
            <Dropdown.Item
              className="py-8"
              onClick={() => navigate(`/${$user.value.userType}/profile/${$user.value.id}`)}
            >
              Profile
            </Dropdown.Item>
            <Dropdown.Item
              className="py-8"
              onClick={() => navigate('/signout')}
            >
              Logout
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <Button
          variant="transparent"
          className={` d-lg-none custom-menu-button ${$app.value.isMenuOpen ? 'is-active' : ''}`}
          onClick={toggleMenu}
        >
          <span />
          <span />
          <span />
        </Button>
      </div>
    </Navbar>
  );
};

export default NavHeader;
